import { formatFilterToObject, formatSortByToObject } from "../helpers";

const ENDPOINTS = {

  ORDER_RETURN: '/get_returns',
  ADD_RETURN:'/add_return'
  
};

export const RETURNS_DEFAULT_PARAMS = {
  itemsPerPage: 25,
  sortBy: formatSortByToObject('return_date', 'desc'),
  filter: formatFilterToObject(),
  page: 1,
};

export default ENDPOINTS;
